<template>
  <div class="checking-log app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
     
	  <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>任务名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入任务名称" v-model="table.search.task_name"></a-input>
          </a-col>
        </a-row>
      </a-col>
	  
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>设备类型</p>
          </a-col>
          <a-col>
			<a-select class="app-block" placeholder="请选择巡查设备类型" v-model="table.search.device_type">
				<a-select-option :value='1'>{{deviceTypes(1)}}</a-select-option>
				<a-select-option :value='2'>{{deviceTypes(2)}}</a-select-option>
				<a-select-option :value='3'>{{deviceTypes(3)}}</a-select-option>
				<a-select-option :value='4'>{{deviceTypes(4)}}</a-select-option>
				<a-select-option :value='5'>{{deviceTypes(5)}}</a-select-option>
				<a-select-option :value='6'>{{deviceTypes(6)}}</a-select-option>
			</a-select>
          </a-col>
        </a-row>
      </a-col>
	  
	  <a-col :span="24" :xl="8">
	    <a-row :gutter="[8, 8]">
	      <a-col>
	        <p>巡检状态</p>
	      </a-col>
	      <a-col>
			<a-select class="app-block" placeholder="请选择巡检状态" v-model="table.search.state">
				<a-select-option :value='1'>{{patioStatus(1)}}</a-select-option>
				<a-select-option :value='2'>{{patioStatus(2)}}</a-select-option>
				<a-select-option :value='3'>{{patioStatus(3)}}</a-select-option>
			</a-select>
	      </a-col>
	    </a-row>
	  </a-col>
	  
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.state === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
		  <a-button type="link">查看</a-button>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
	
  import Check from '@/io/check.js'
  import { deviceTypes,patioStatus } from '@/io/dict.js'
	
  export default {
    name: 'CheckingLog',
	props: {
	  communityId: {
	    type: Number,
	    default: null
	  },
	},
    data() {
      let self = this;
      return {
			deviceTypes,
			patioStatus,
        table: {
          loading: false,
          search: {
			task_name:null,
            device_type: [],
            state: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '项目名称',
              dataIndex: 'community_name'
            },
			{
			title: '任务名称',
			dataIndex: 'task.task_name'
			},  	
            {
              title: '设备类型',
              dataIndex: 'device_type.id'
            },
            {
              title: '设备名称',
              dataIndex: 'device.name'
            },
			{
				title: '设备编号',
				dataIndex: 'device.device_sn'
			},
			{
				title: '空间位置',
				dataIndex: 'device.position'
			},
			{
				title: '巡检类型',
				dataIndex: 'type'
			},
			{
				title: '巡检时间',
				dataIndex: 'patrol_time'
			},
			{
				title: '巡检状态',
				dataIndex: 'state'
			},     
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        }
      }
    },
	
	activated() {
		this.initData()
	},
    methods: {
    
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
		  task_name:null,
		  device_type: [],
		  state: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
	 
      initData() {
        this.table.loading = true;
        return Check.listPage(
		
		  this.table.search.task_name,
          this.table.search.device_type,
		  // this.table.search.type,
          this.table.search.state,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            // val.region = `${val.province} / ${val.city} / ${val.area}`;
            // val.stateLoading = false;
            // val.intercom = val.mj_switch ? '开' : '关';
            // val.gate = val.gate_switch ? '开' : '关';
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>